import { createReducer } from 'redux-create-reducer';
import { UPDATE_PROGRESS_BAR } from '../actions';

const initialState = {
  disableAddNewDevice: true,
  disableNext: true,
  onCompletion: () => {},
  showCart: false,
  nextTip: null,
};

const events = {
  [UPDATE_PROGRESS_BAR]: (
    state,
    { disableAddNewDevice, disableNext, onCompletion, showCart, nextTip }
  ) => {
    return {
      ...state,
      disableAddNewDevice,
      disableNext,
      onCompletion,
      showCart,
      nextTip,
    };
  },
};

export default createReducer(initialState, events);
